export function fetchClaimReport({ reportId }) {
  return {
    endpoint: `reports/${reportId}`,
    method: 'GET',
    requireAuth: false,
  };
}



// WEBPACK FOOTER //
// ./src/api/config/claim-reports.js